import { enableProdMode, Testability } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@kp/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.warn(err));

/**
 * Used by Cypress.waitForAngularIdle() (in commands.ts) to wait for all Pending request to finish
 */
interface NgIsStableOptions {
  timeout?: number;
  updater?: (update) => void;
  logging?: boolean;
}
function ngIsStable(options: NgIsStableOptions = { timeout: 1000, logging: false }): Promise<boolean> {
  // you need to select an element managed by Angular. Usually any div in your html body
  const test = (window as any).getAngularTestability(window.document.querySelector('body main')) as Testability;
  const isStable = new Promise<boolean>((resolve, reject) => {
    test.whenStable(doneCb, options.timeout /*, updateCb*/);

    function doneCb(value) {
      if (options.logging) {
        console.log(value);
      }
      if (value) {
        resolve(!!value);
      } else {
        reject(!!value);
      }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function updateCb(update) {
      // To figure out before this will work:
      // "Task tracking zone is required when passing an update callback "
      if (typeof options.updater === 'function') {
        return options.updater;
      }
      if (options.logging) {
        console.log(update);
      }

      // Comment in the following to check stability during updates
      // const stable = test.isStable();
      // // this console.log block is just for information/debugging
      // console.log('Angular is ' + (stable ? '' : 'NOT ') + 'stable:', {
      //   pendingRequestCount: test.getPendingRequestCount(),
      //   _pendingCount: (test as any)._pendingCount,
      //   pendingTasks: (test as any).getPendingTasks(),
      // });

      // NOTE: updateCb should return undefined to continue
    }
  });

  return isStable;
}

window['ngIsStable'] = ngIsStable;
